module.exports = __webpack_public_path__ + "static/img/RAW_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAW_1.png
// module id = eXvc
// module chunks = 0